import { type LocationListingQuery } from 'cms/cms';
import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from './imageResolver';
import { type ContentModelReference } from 'cms/cms-types';
import { type LocationCardProps } from '4-sections/LocationListing/LocationCard';

export type LocationPage = NonNullable<LocationListingQuery['LocationPage']>;
export type LocationPageItems = NonNullable<LocationPage['items']>;

export interface LocationCardResolverSettings {
    faxLabel: string;
    telLabel: string;
}

export interface GenerateDescriptionProps {
    Address?: string | null;
    FaxNumber?: string | null;
    PhoneNumber?: string | null;
    faxLabel: string;
    telLabel: string;
}

export const generateDescription = ({ Address, FaxNumber, PhoneNumber, faxLabel, telLabel }: GenerateDescriptionProps): string => {
    const faxNumber = FaxNumber ? `<span>${faxLabel}:</span> <span>${FaxNumber}</span><br />` : '';
    const telNumber = PhoneNumber ? `<span>${telLabel}:</span> <a href="tel:${PhoneNumber}">${PhoneNumber}</a>` : '';
    const additionalInfo = faxNumber || telNumber ? `<p>${faxNumber}${telNumber}</p>` : '';
    return `${Address}${additionalInfo}`;
};


export const resolveLocationPagesToLocationCards = (items: LocationPageItems, settings: LocationCardResolverSettings): LocationCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, Address, FaxNumber, PhoneNumber, ContentLink, PreviewImage } = item as NonNullable<typeof item>;
        const { faxLabel, telLabel } = settings;
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=1280', imgSrcSets);
        const description = generateDescription({ Address, FaxNumber, PhoneNumber, faxLabel, telLabel });

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(Address && { children: HTMLReactParser(description as string) }),
            ...(img && { img }),
        };
    });
};
